export default __webpack_public_path__ + "static/sgcodecampus-skillsfuture-apple-0e0420ef7b588a3f319b19a1734e6fd4.jpg";